"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parentCompanySchema = void 0;
var _zod = require("zod");
var parentCompanySchema = () => {
  return _zod.z.object({
    parentCompanyName: _zod.z.string().trim().optional()
  });
};
exports.parentCompanySchema = parentCompanySchema;